import { createContext } from 'react';

// set initial value of stepper to null
const StepperContext = createContext(null);

export default StepperContext;
